import { Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation } from '@angular/core';
  import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
  } from '@angular/material/dialog';
import { GeneralService } from '../../../../services/general/general.service';
import { ActivatedRoute } from '@angular/router';
import { id } from 'date-fns/locale';
import { DateTime, Zone } from 'luxon';
import { GrupalPaymentModalComponent } from 'src/app/components/grupal-payment-modal/grupal-payment-modal.component';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-class-detail',
  templateUrl: './class-detail.component.html',
  styleUrls: ['./class-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClassDetailComponent implements OnInit {
  
  public loading: any = false;
  public classId: any = [];
  public isMobile: any;
  public infoClass: any;
  public subscriptions: any = []; 
  public loading2 = false;
  public teacher_lessons: any;
 
  currentLocale: string | null;

  public ios: boolean | undefined;

  constructor(
    
    public general: GeneralService,  
    private route:ActivatedRoute,
    private dialog: MatDialog,
    
  ) {   
    if (Capacitor.getPlatform() === 'ios') {
      this.ios = true;
    }else{
      this.ios = false;
    }

    this.currentLocale = this.general.getCurrentLocale();
   this.isMobile = this.general.isMobile();  
   }

   openWordiix(){
    window.open("https://app.wordiix.com/", '_self');
  }
  
  async ngOnInit() {    

    this.general.setLoading(true);   

    try {
      await this.intializeSubscriptions();
      this.classId = this.route.snapshot.paramMap.get('id');
      await  this.getInfoClass();
    } catch (error) {
      console.log(error);
      
    } finally {
      
      await this.general.setLoading(false);
    }  
    

  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  async intializeSubscriptions() {
    this.subscriptions = await [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ]; 
    
  }

  async getInfoClass () {

    try {
      
      await this.general.setLoading(true);
      const response = await this.general.httpPost('groupal-class-info',{groupal_class_id:this.classId,});
      this.infoClass = response.message;
      const timezone = this.general.getCurrentTimezone();
      this.infoClass.date = DateTime.fromFormat(this.infoClass.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
      this.infoClass.date = this.infoClass.date.setLocale(this.currentLocale).toFormat('dd/MM/yyyy');
      this.infoClass.hour = DateTime.fromFormat(this.infoClass.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
      this.infoClass.hour = this.infoClass.hour.setLocale(this.currentLocale).toFormat('HH:mm');

      const key1 = 'id';        
      this.teacher_lessons = await [...new Map(this.infoClass.teacher.lessons.map((item: { [x: string]: any; }) =>
        [item[key1], item])).values()];

    } catch (error) {
      console.log(error);
    }
    
  } 

  showPaymentGroupalDialog() {
    const data = {
      name: this.infoClass.name,
      teacher_name: this.infoClass.teacher.fullName,
      price: this.infoClass.price,
      date: this.infoClass.date,
      hour: this.infoClass.hour,
      class_id: this.classId
    };


    const dialogRef = this.dialog.open(GrupalPaymentModalComponent, {
      data,
      autoFocus: false,
      disableClose: true,
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        this.loading2 = true;

        const body = {
          type: 'single',            
          payment_method: data.paymentMethod,    
        };

        const response = await this.general.httpPost('groupal-buy', body);

        window.location.href = response.data.data;
      } catch (e: any) {
        
        this.loading2 = false;
      } 
    });
  }

}
